import { Badge } from "@/components/ui/badge";
import type { NumberRequestWaitingOn } from "@/features/admin";

/**
 * Whose move it is, as the back-office reads it.
 *
 * The state badge already says *where* a request is; on a queue of every
 * tenant's requests the question that comes first is *whose* it is — ours to
 * work, the carrier's to answer, or the client's to finish. Everything on this
 * page is sorted by it, so it is worth a colour of its own.
 */
const LABELS: Record<
  NumberRequestWaitingOn,
  { label: string; variant: "default" | "secondary" | "outline" }
> = {
  heyup: { label: "Chez nous", variant: "default" },
  carrier: { label: "Chez l'opérateur", variant: "secondary" },
  client: { label: "Chez le client", variant: "outline" },
  none: { label: "Clôturée", variant: "outline" },
};

export function WaitingOnBadge({ waitingOn }: { waitingOn: NumberRequestWaitingOn }) {
  const { label, variant } = LABELS[waitingOn] || LABELS.none;
  return <Badge variant={variant}>{label}</Badge>;
}

export const waitingOnLabel = (waitingOn: NumberRequestWaitingOn) =>
  (LABELS[waitingOn] || LABELS.none).label;
